import React from "react";
import Sidebar from "../../components/sidebar/Sidebar";
import MainSection from "../../components/mainLayout/Main";
import SectionHeader from "../../components/sectionHeader/SectionHeader";
import CalendarHome from "./components/CompliancesHome";

const CompliancesAndEvents = () => {
  return (
    <>
      <Sidebar />
      <MainSection>
        <SectionHeader title="" />
        <CalendarHome />
      </MainSection>
    </>
  );
};

export default CompliancesAndEvents;
